"use client";

import Image from "next/image";

interface HeroSectionProps {
  title: string;
  subtitle: string;
}

export function HeroSection({ title, subtitle }: HeroSectionProps) {
  return (
    <section
      className="relative overflow-hidden min-h-75 flex items-center justify-center pt-20"
      style={{
        background: 'linear-gradient(135deg, #0C1A2E 30%, #285494 70%, #285494 100%)',
      }}
    >
      {/* Animated Stars */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Star 1 */}
        <div
          className="absolute top-[10%] left-[5%] opacity-30"
          style={{
            animation: 'float 4s ease-in-out infinite',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={50} height={50} />
        </div>

        {/* Star 2 */}
        <div
          className="absolute top-[20%] right-[15%] opacity-40"
          style={{
            animation: 'float 6s ease-in-out infinite 1s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={70} height={70} />
        </div>

        {/* Star 3 */}
        <div
          className="absolute top-[60%] left-[10%] opacity-35"
          style={{
            animation: 'float 5s ease-in-out infinite 2s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={60} height={60} />
        </div>

        {/* Star 4 */}
        <div
          className="absolute bottom-[15%] right-[20%] opacity-30"
          style={{
            animation: 'float 7s ease-in-out infinite 1.5s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={55} height={55} />
        </div>

        {/* Star 5 */}
        <div
          className="absolute top-[40%] left-[25%] opacity-25"
          style={{
            animation: 'float 3s ease-in-out infinite 0.5s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={45} height={45} />
        </div>

        {/* Star 6 */}
        <div
          className="absolute top-[70%] right-[8%] opacity-40"
          style={{
            animation: 'float 8s ease-in-out infinite 3s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={65} height={65} />
        </div>

        {/* Star 7 */}
        <div
          className="absolute top-[15%] left-[35%] opacity-20"
          style={{
            animation: 'float 5s ease-in-out infinite 2.5s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={40} height={40} />
        </div>

        {/* Star 8 */}
        <div
          className="absolute top-[50%] right-[30%] opacity-35"
          style={{
            animation: 'float 7s ease-in-out infinite 1.2s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={58} height={58} />
        </div>

        {/* Star 9 */}
        <div
          className="absolute bottom-[25%] left-[15%] opacity-28"
          style={{
            animation: 'float 4s ease-in-out infinite 3.5s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={28} height={28} />
        </div>

        {/* Star 10 */}
        <div
          className="absolute top-[35%] right-[10%] opacity-30"
          style={{
            animation: 'float 6s ease-in-out infinite 1.8s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={52} height={52} />
        </div>

        {/* Star 11 */}
        <div
          className="absolute top-[80%] left-[30%] opacity-25"
          style={{
            animation: 'float 3s ease-in-out infinite 4s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={42} height={42} />
        </div>

        {/* Star 12 */}
        <div
          className="absolute bottom-[35%] right-[5%] opacity-38"
          style={{
            animation: 'float 8s ease-in-out infinite 2.8s',
          }}
        >
          <Image src="/homepage/homepage-picture/star.svg" alt="" width={62} height={62} />
        </div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 text-center px-8 lg:px-16">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
          {title}
        </h1>
        <p className="text-l md:text-xl text-white opacity-90 max-w-2xl mx-auto">
          {subtitle}
        </p>
      </div>

    </section>
  );
}

